declare var $: any;

export class Navigation {
    // Adds a hidden field representing the direction of the move
    static init() {
        $("body").on("click", ".back-button", function(e: Event) {
            e.preventDefault();
            Navigation.addDirectionElement("Back", $(this));
        });
        $("body").on("click", ".forward-button", function(e: Event) {
            e.preventDefault();
            Navigation.addDirectionElement("Forward", $(this));
        });
    }

    static addDirectionElement(direction: string, $button: any) {
        const dontSubmit: boolean = $button.data("override-navigation");
        const $mainSubmitForm = $("form.js-main-submit-form");
        const $form = $mainSubmitForm.length > 0 ? $mainSubmitForm : $button.closest("form");

        $("<input>").attr("type", "hidden").attr("name", "direction").attr("value", direction).appendTo($form);
        if (dontSubmit) return;
        $form.submit();
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/partials/navigation.ts